import { Component, OnInit, Inject, NgZone } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";
import { UserPanelService } from "../user-panel.service";
import { Router } from "@angular/router";
import { ExtensionAlertDialogComponent } from "./extension-alert-dialog/extension-alert-dialog.component";
import { AngularFireAuth } from "@angular/fire/auth";
declare const chrome: any;

@Component({
  selector: "app-clips-dialog",
  templateUrl: "./clips-dialog.component.html",
  styleUrls: ["./clips-dialog.component.scss"],
})
export class ClipsDialogComponent implements OnInit {
  isMobile = false;
  hasExtension = true;
  constructor(
    private dialogRef: MatDialogRef<ClipsDialogComponent>,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private userPanelService: UserPanelService,
    private router: Router,
    private zone: NgZone,
    private auth: AngularFireAuth
  ) {
    // if (window.outerWidth < 993) {
    // this.isMobile = true;
    this.hasExtension = true;
    // } else {
    this.auth.idToken.subscribe((token) => {
      console.log(token);
      try {
        chrome.runtime.sendMessage(
          "hfaieeklblendoodjfmgaecekjocnigl",
          {
            token: token,
          },
          (reply) => {
            this.zone.run(() => {
              // <== added
              if (reply) {
                if (reply.status) {
                  if (reply.status === 200) {
                    this.hasExtension = true;
                    console.log(this.hasExtension);
                  }
                }
              } else {
                this.hasExtension = false;
                console.log(this.hasExtension);
              }
            });
          }
        );
      } catch (err) {
        console.log(err);
        this.hasExtension = false;
      }
    });
    // }
  }

  ngOnInit(): void {}
  selectClip(clipName) {
    if (!this.hasExtension) {
      this.dialog.open(ExtensionAlertDialogComponent, {
        width: "65vw",
        height: "75vh",
      });
    } else {
      this.userPanelService.clipName = clipName;
      if (this.data.subjectName == "Projektovanje softvera - C#")
        this.data.subjectName = "Projektovanje softvera - C Sharp";
      this.userPanelService.subjectName = this.data.subjectName;
      this.router.navigateByUrl("klip");
      this.dialogRef.close();
    }
  }
}
